import React from 'react'
import { useTranslation } from 'react-i18next'
import InputLabel from 'components/ui/forms/field/input-label/InputLabel'
import CheckBoxRadioButtonInput from 'components/ui/forms/field/checkbox-radiobutton/CheckBoxRadioButtonInput'

interface DenyDownloadProps {
  checked: boolean
  onChange: (value: boolean) => void
}

const DenyDownload: React.FC<DenyDownloadProps> = ({ checked, onChange }) => {
  const { t } = useTranslation()

  return (
    <div>
      <InputLabel
        label={t('administration.blocks.type.multimedia.allowDownload.title')}
      />
      <CheckBoxRadioButtonInput
        name={'denyDownload-radio-true'}
        value={true}
        checked={checked}
        inline={true}
        type={'radio'}
        label={t('administration.blocks.type.multimedia.allowDownload.yes')}
        onChange={() => {
          onChange(true)
        }}
        error={''}
      />
      <CheckBoxRadioButtonInput
        name={'denyDownload-radio-false'}
        value={false}
        checked={!checked}
        inline={true}
        type={'radio'}
        label={t('administration.blocks.type.multimedia.allowDownload.no')}
        onChange={() => {
          onChange(false)
        }}
        error={''}
      />
    </div>
  )
}

export default DenyDownload
